module.exports = __webpack_public_path__ + "img/caag1030_setting.337cbe9f.png";